export default function OrganizerDetails() {
  return (
    <div className="bg-neutral-100/95 py-8 px-1 mb-12">
      <h2 className="text-lg font-medium mb-8">Organizer Details</h2>

      <div className="grid md:grid-cols-2 gap-x-20 gap-y-10">
        <input name="organizerName" placeholder="Organizer’s Name" className="input-style" />
        <input name="contactPerson" placeholder="Contact Person" className="input-style" />
        <input name="contactNo" placeholder="Contact No." className="input-style" />
        <input type="email" name="email" placeholder="Email Address" className="input-style" />
      </div>
    </div>
  );
}